import { render, staticRenderFns } from "./gatewayConfig.vue?vue&type=template&id=4f942cfb&scoped=true"
import script from "./gatewayConfig.vue?vue&type=script&lang=js"
export * from "./gatewayConfig.vue?vue&type=script&lang=js"
import style0 from "./gatewayConfig.vue?vue&type=style&index=0&id=4f942cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f942cfb",
  null
  
)

export default component.exports